import { lowerFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Alert, IconButton, Link } from '@mui/joy';

import { trpc } from '@/config/trpc';
import { useUserRole } from '@/queries';

import { OpenIcon, WarningIcon } from '@/shared/icons/Icons';

const InactiveIntegrations: React.FC = () => {
  const { t } = useTranslation();
  const { isSupervisor } = useUserRole();
  const { data: integrations } = trpc.integration.list.useQuery();

  if (integrations?.every((integration) => integration.isActive) || !isSupervisor || !integrations)
    return null;

  return (
    <Alert
      className="my-2 w-fit"
      size="lg"
      startDecorator={<WarningIcon />}
      color="danger"
      endDecorator={
        <IconButton
          variant="plain"
          color="neutral"
          component={Link}
          target="_blank"
          href="/team/settings/integrations"
        >
          <OpenIcon />
        </IconButton>
      }
    >
      <div>
        {integrations
          .filter((integration) => !integration.isActive)
          .map((integration) => (
            <div>
              {t('anIntegrationNeedsYourAttention', {
                integration: t(`_integrationPartner.${lowerFirst(integration.partner)}`),
              })}
            </div>
          ))}
      </div>
    </Alert>
  );
};

export default InactiveIntegrations;
